<template>
    <div class="py-2">
        <hts-charges
            ref="chargeEditor"
            v-model="charges"
            :editable="editable"
            :api="$urlPartner.monitoring.journey.pricing.update"
            :uri-params="uriParams"
            simple
            @modified="handleModified" />
        <div class="font-medium">
            <div class="text-error-500">
                <span class="mr-1">
                    Tổng chi phí:
                </span><b>
                    {{ $formatters.formatCurrency(pricingEstimate?.cost || 0, 0) }}
                </b>
            </div>
            <div class="text-blue-500">
                <span class="mr-1">
                    Tổng doanh thu:
                </span><b>
                    {{ $formatters.formatCurrency(pricingEstimate?.revenue || 0, 0) }}
                </b>
            </div>
            <div class="text-green-500">
                <span class="mr-1">
                    Tổng lợi nhuận:
                </span><b>
                    {{ $formatters.formatCurrency(pricingEstimate?.profit || 0, 0) }}
                </b>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { checkPermission } from '@/utils/permission-check'
const props = defineProps({
  journey: {
    type: Object,
    required: true
  }
})

const emits = defineEmits(['modified'])
const { journey } = toRefs(props)
const journeyId = computed(() => journey.value?.id)
const editable = computed(() => checkPermission(['monitoring_journey_pricing_view']))
const chargeEditor = ref<any>(null)
const charges = computed<any[]>(() => journey.value?.charges || [])
const pricingEstimate = computed<any>(() => journey.value?.pricingEstimate)
const uriParams = computed(() => {
  return {
    ID: journeyId.value
  }
})
const handleModified = () => {
  emits('modified')
}
</script>
